import { Box, Checkbox, FormControlLabel } from "@mui/material";
import { useController, Control, Controller } from "react-hook-form";
import { ProfileFormData, NotificationOptions } from "./profile-form-data";
import { useTranslation } from "react-i18next";

interface Props {
  control: Control<ProfileFormData>;
  editMode: boolean;
  notificationOptions: NotificationOptions[];
}

export const ProfileEmailNotification = (props: Props) => {
  const { control, editMode, notificationOptions } = props;
  const { t } = useTranslation();

  return (
    <Box>
      {notificationOptions.map((options, index) => (
        <Box key={index}>
          {/* Hidden controller to preserve notificationType */}
          <Controller
            name={`notificationOptions.${index}.notificationType`}
            control={control}
            defaultValue={notificationOptions[index].notificationType}
            render={({ field }) => <input type="hidden" value={field.value ?? ""} onChange={field.onChange} />}
          />

          {/* Existing checkbox controller for value */}
          <Controller
            name={`notificationOptions.${index}.value`}
            control={control}
            defaultValue={notificationOptions[index].value}
            render={({ field }) => <FormControlLabel control={<Checkbox disabled={!editMode} checked={field.value} onChange={(e, checked) => field.onChange(checked)} />} label={t("account.profilePage.emailNotificationLabel")} />}
          />
        </Box>
      ))}
    </Box>
  );
};
